import React, { useContext, useEffect, useState } from 'react';
import { Card, CardContent, Typography, Button, TextField, MenuItem, Select, FormControl, InputLabel, Box, Grid, Chip, Paper } from '@mui/material';
import { AddUpdate, getPostData, getPostTicketData } from '../../../ApiMethods/ApiMethods';
import moment from 'moment';

const ticketsData = [
    {
        TicketId: 'TKT1001',
        Subjects: 'Issue with chat history',
        CurrentStatus: 'Open',
        Name: 'Rahul Sharma',
        created: '2025-06-01',
        Message: 'I can\'t see my chat ',
        AdminReply: 'Please try logging out',
        UserId: '1',
    },
    {
        TicketId: 'TKT1002',
        Subjects: 'Puja Booking not showing',
        CurrentStatus: 'In Progress',
        Name: 'Sneha Patel',
        created: '2025-06-02',
        Message: 'I can\'t astrologer booking .',
        AdminReply: ' We\'re investigating this further.',
    },
    {
        TicketId: 'TKT1003',
        Subjects: 'App crashing on Android',
        CurrentStatus: 'Closed',
        Name: 'Amit Verma',
        created: '2025-06-03',
        Message: 'I can\'t see my chat history with astrologer .',
        AdminReply: 'AdminReply reply please',
    },
];

const statusColor = {
    Open: 'warning',
    'In Progress': 'info',
    Closed: 'success',
};

export default function Support() {

    const UserLoginId = "";

    const [selectedTicket, setSelectedTicket] = useState();
    const [ticketData, setTicketData] = useState([]);
    const [status, setStatus] = useState(selectedTicket?.CurrentStatus || "Open");
    const [filterStatus, setFilterStatus] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [ticketMessages, setticketMessages] = useState([]);
    const [reply, setReply] = useState('');
    const [PriorityValue, setPriorityValue] = useState('');
    const [TicketCategory, setTicketCategory] = useState('');


    const filteredTickets = ticketData.filter(ticket => {
        const matchesStatus = filterStatus === 'All' || ticket.CurrentStatus === filterStatus;
        const matchesSearch = ticket?.Subjects?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
            ticket?.user?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
            ticket?.Message?.toLowerCase()?.includes(searchQuery?.toLowerCase());
        return matchesStatus && matchesSearch;
    });
  


    useEffect(() => { Get_Ticket(); }, []);

    const Get_Ticket = async () => {
        try {
            const response = await getPostData('Ticket/Get_Ticket', { UserId: 0 });
          
            if (response) {
                setTicketData(response);

            } else {
                console.error('No response data received from Get_Ticket API');
                setTicketData([]);
            }
        } catch (error) {
            console.error('Error fetching tickets:', error);

        }
    };

    const Get_Data_Ticket = async (TicketNumber) => {
        try {
            const response = await getPostTicketData('Ticket/GetData_Ticket', { TicketNumber: TicketNumber });
            if (response) {
                const Ticket = response?.Ticket ? JSON.parse(response?.Ticket) : [];
                const TicketDetail = response?.TicketDetail ? JSON.parse(response?.TicketDetail) : [];
                setticketMessages(TicketDetail);
                const mergedData = [...Ticket, ...TicketDetail];
            }
        } catch (error) {
            console.error('Error fetching or processing ticket data:', error);
        }
    };

    const Insert_Ticket = async () => {
        const file = "";

        const data = {
            Subjects: selectedTicket?.Subjects ? selectedTicket?.Subjects : "",
            CurrentStatus: status,
            Name: selectedTicket?.Name ? selectedTicket?.Name : "",
            CreatedByUser: 0,
            Message: reply,
            UserId: 0,
            Email: selectedTicket?.Email ? selectedTicket?.Email : "",
            TicketNumber: selectedTicket?.TicketNumber ? selectedTicket?.TicketNumber : "",
            AstrologerId: 0,
            PriorityValue: PriorityValue,
            TicketCategory: TicketCategory,
            Priority: selectedTicket?.Priority ? selectedTicket?.Priority : "",
        };

        const formData = new FormData();
        formData.append("Data", JSON.stringify(data));
        formData.append("File", file);

        const response = await AddUpdate('Ticket/Insert_Ticket', formData);

        if (response) {
            setFilterStatus('All');
            Get_Data_Ticket(selectedTicket?.TicketNumber);
            Get_Ticket();
            setSelectedTicket()
        }
    }

    return (
        <>
        <div >   
            <Box sx={{
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                bgcolor: 'background.default',
                border:"2px solid orange",borderRadius:"10px",padding:"10px"
            }}>

                <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant={filterStatus === 'All' ? 'contained' : 'outlined'}
                            onClick={() => {
                                setFilterStatus('All'); setSelectedTicket(null); setticketMessages(); Get_Ticket();
                            }}
                            sx={{
                                bgcolor: filterStatus === 'All' ? 'orange' : 'transparent',
                                color: filterStatus === 'All' ? 'white' : 'inherit',
                                '&:hover': { bgcolor: 'darkorange' }
                            }}
                        >
                            All Tickets
                        </Button>
                        <Button
                            variant={filterStatus === 'Open' ? 'contained' : 'outlined'}
                            onClick={() => {
                                setFilterStatus('Open'); setSelectedTicket(null); setticketMessages();
                            }}
                            sx={{
                                bgcolor: filterStatus === 'Open' ? 'orange' : 'transparent',
                                color: filterStatus === 'Open' ? 'white' : 'inherit',
                                '&:hover': { bgcolor: 'darkorange' }
                            }}
                        >
                            Open
                        </Button>
                        <Button
                            variant={filterStatus === 'In Progress' ? 'contained' : 'outlined'}
                            onClick={() => {
                                setFilterStatus('In Progress'); setSelectedTicket(null); setticketMessages();
                            }}
                            sx={{
                                bgcolor: filterStatus === 'In Progress' ? 'orange' : 'transparent',
                                color: filterStatus === 'In Progress' ? 'white' : 'inherit',
                                '&:hover': { bgcolor: 'darkorange' }
                            }}
                        >
                            In Progress
                        </Button>
                        <Button
                            variant={filterStatus === 'Closed' ? 'contained' : 'outlined'}
                            onClick={() => {
                                setFilterStatus('Closed'); setSelectedTicket(null); setticketMessages();
                            }}
                            sx={{
                                bgcolor: filterStatus === 'Closed' ? 'orange' : 'transparent',
                                color: filterStatus === 'Closed' ? 'white' : 'inherit',
                                '&:hover': { bgcolor: 'darkorange' }
                            }}
                        >
                            Closed
                        </Button>
                    </Box>
                </Box>

                <Grid container spacing={3}>
                    {/* Ticket List */}
                    <Grid item style={{width:"50vw"}} xs={24} md={6}>
                        <Typography variant="h6" sx={{ color: 'orange' }}>Support Tickets</Typography>
                        <Box
                            sx={{
                                height: 500,
                                overflowY: 'auto',
                                pr: 1,
                                mt: 2,
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#ffa726',
                                    borderRadius: '8px',
                                },
                            }}
                        >
                            {filteredTickets?.map((ticket) => (
                                <Card
                                    key={ticket?.TicketId}
                                    onClick={() => {
                                        setSelectedTicket(ticket);
                                        setStatus(ticket?.CurrentStatus ? ticket.CurrentStatus : 'Open');
                                        Get_Data_Ticket(ticket?.TicketNumber);
                                    }}
                                    sx={{
                                        mb: 2,
                                        cursor: 'pointer',
                                        borderColor: selectedTicket?.TicketId === ticket?.TicketId ? 'orange' : 'grey.300',
                                        borderWidth: 2,
                                        borderStyle: 'solid',
                                        transition: '0.3s',
                                    }}
                                >
                                    <CardContent>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                           
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    overflowX: "auto",
                                                    display: "block",
                                                    maxWidth: "180px", 
                                                    "&::-webkit-scrollbar": {
                                                        height: "4px",
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        backgroundColor: "#888",
                                                        borderRadius: "2px",
                                                    },
                                                }}
                                            >
                                                {ticket.Subjects}
                                            </Typography>

                                            <Chip label={ticket.CurrentStatus} style={{ pointerEvents: "none", cursor: "default" }} color={statusColor[ticket.CurrentStatus]} size="small" />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary">
                                            By {ticket.Name} • {moment(ticket.CreatedDtTm).format('MMM DD, YYYY HH:mm')}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </Grid>
                    <Grid  style={{width:"35vw"}} item xs={12} md={6}>
                        <Typography variant="h6" sx={{
                                                    whiteSpace: "nowrap",
                                                    overflowX: "auto",
                                                    display: "block",
                                                    maxWidth: "380px", 
                                                    "&::-webkit-scrollbar": {
                                                        height: "4px",
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        backgroundColor: "#888",
                                                        borderRadius: "2px",
                                                    },
                                                }}>
                            #{selectedTicket?.TicketNumber} - {selectedTicket?.Subjects}
                        </Typography>

                        <Paper variant="outlined" sx={{ mb: 2, p: 2 }}>
                            {ticketMessages?.map((ticket, index) => {
                                const attachments = [ticket?.Attachment1, ticket?.Attachment2, ticket?.Attachment3]
                                    .filter(att => att && att.trim() !== "")
                                    .map(att => att.replace(/\\/g, "/"));

                                return (
                                    <div style={{ width: "100%" }} key={index}>
                                        {ticket?.State !== "Admin" ? (
                                            <Typography variant="body2" sx={{ mb: 1 }}>
                                                <strong>User message:</strong> {ticket?.Message}{" "}
                                                {attachments.length > 0 ? (
                                                    attachments.map((file, i) => {
                                                        const url = `https://${file}`;
                                                        const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);

                                                        return (
                                                            <span key={i} style={{ marginLeft: "8px" }}>
                                                                <strong>Attachment :</strong>{" "}
                                                                {isImage ? (
                                                        
                                                                    <a href={url} style={{color:"blue",fontWeight:"bold"}} target="_blank" rel="noopener noreferrer">
                                                                        {/* View Image */}
                                                                         <i className="fa fa-eye" aria-hidden="true"></i> View

                                                                    </a>
                                                                ) : (
                                                                    
                                                                    <a href={url} style={{color:"black",fontWeight:"bold"}} target="_blank" rel="noopener noreferrer">
                                                                        View File
                                                                    </a>
                                                                )}
                                                            </span>
                                                        );
                                                    })
                                                ) : (
                                                    <span>
                                                        <strong></strong>
                                                    </span>
                                                )}
                                            </Typography>
                                        ) : (
                                            <Typography variant="body2" sx={{ mb: 1 }}>
                                                <strong>Admin reply:</strong> {ticket?.Message}
                                            </Typography>
                                        )}
                                    </div>
                                );
                            })}
                        </Paper>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <TextField
                                multiline
                                minRows={4}
                                label="Write a reply"
                                value={reply}
                                onChange={(e) => setReply(e.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <FormControl size="small">
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        value={status}
                                        label="Status"
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <MenuItem value="Open">Open</MenuItem>
                                        <MenuItem value="In Progress">In Progress</MenuItem>
                                        <MenuItem value="Closed">Closed</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="contained"
                                    sx={{ bgcolor: 'orange', '&:hover': { bgcolor: 'darkorange' } }}
                                    onClick={() => { setReply(''); Insert_Ticket() }}
                                    disabled={!selectedTicket}
                                >
                                    Send Reply
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            </div>
        </>
    );
}
